import { AfterViewInit, Directive, Input, OnDestroy, OnInit, Type } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { UserSystemLog } from "projects/sepidz-web-framework/src/lib/models/user-System-Log.model";
import { AccountService, HttpCommonService, ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { Subject } from "rxjs";
import { take } from "rxjs/operators";
import { AppInjector } from "../../shared.module";

@Directive()
export class BaseListComponent implements OnInit, OnDestroy, AfterViewInit {
  protected defaultSortKey: string;
  protected accountService: AccountService;
  @Input() apiName: string = "";
  @Input() areaName: string = "";
  @Input() reportName: string = "";
  public label: string = "";
  public pagingSize: number = 15;
  public noToolBar: boolean = false;
  public paging: boolean = true;
  public filtrableFields: string = "";
  public isAdd: boolean = true;
  public NoLog: boolean = false;
  public isEdit: boolean = true;
  public isDelete: boolean = true;
  public isMulti: boolean = false;
  public isModal: boolean = true;
  public isHideFooter: boolean = false;
  public systemName: string;
  public category: string;
  public columns: form_control[] = [];
  public orignalColumns: form_control[] = [];
  public inputEditorform: Type<any>;
  public target?: any;
  public actions: any[];
  public dataList: any[];
  protected ngUnsubscribe = new Subject<void>();
  protected dialogService: SimpleModalService;
  protected translateText: TranslateService;
  protected httpCommonService: HttpCommonService;
  public currentTabId: string = "";
  public group: UntypedFormGroup;
  public isMultiBranch: boolean;

  public get sts() {
    return AppInjector.get(ShowToastrService);
  }

  constructor() {
    this.accountService = AppInjector.get(AccountService);
    this.dialogService = AppInjector.get(SimpleModalService);
    this.translateText = AppInjector.get(TranslateService);
    this.httpCommonService = AppInjector.get(HttpCommonService);

    const info = this.accountService.authService.currentInformation();
    this.isMultiBranch =
      (info.BranchingAdvancedEnabled || info.BranchingLightEnabled || info.RestaurantCallCenter) &&
      this.accountService.authService.currentBranch?.AccessToAllBranches;
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    if (!this.NoLog) this.setUserSystemLog();
  }

  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
    this.columns = undefined;
    this.orignalColumns = undefined;
    this.group = undefined;
    this.inputEditorform = undefined;
    this.target = undefined;
    this.actions = undefined;
    this.dataList = undefined;
    this.dialogService = undefined;
    this.httpCommonService = undefined;
  }

  onCreate(event: any) {}
  onEdit(event: any) {}
  onDelete(event: any) {}
  onRowSelected(event: any) {}

  translate(str: string): string {
    return this.translateText.instant(str);
  }

  protected getDataFromFormGroup(model: any) {
    Object.keys(this.group.controls).forEach((key) => {
      model[key] = this.group.controls[key].value;
    });
    return model;
  }

  filterColumns(view: any) {
    const filterObject = Object.keys(view);
    const main = [];
    filterObject.forEach((ele) => {
      const findItem = this.columns.find((f) => f.name === ele.toString());
      if (findItem) main.push(findItem);
    });
    this.columns = main;
  }

  setUserSystemLog() {
    if (!this.httpCommonService) return;
    let log: UserSystemLog = <UserSystemLog>{};
    const currentUser = this.accountService.authService.currentUser;
    log.UserId = currentUser.Id;
    log.UserName = currentUser.UserName;
    log.DisplayName = currentUser.DisplayName;
    log.SystemName = this.areaName.length > 20 ? this.areaName.substring(20) : this.areaName;
    log.FormName = this.constructor.name.length > 100 ? this.constructor.name.substring(100) : this.constructor.name;
    log.FormTitle = this.label.length > 100 ? this.label.substring(100) : this.label;
    this.httpCommonService
      .create("UserSystemLog", log)
      .pipe(take(1))
      .subscribe(
        (x) => {},
        (error) => {
          console.timeLog(error);
        }
      );
  }

  setValue(key: string, value: any, validator: boolean = false, patternKey: string = undefined) {
    if (!this.group) {
      let groupCustom: any = {};
      this.group = new UntypedFormGroup(groupCustom);
    }

    const controls = this.group.controls;
    if (!controls[key]) this.group.addControl(key, new UntypedFormControl(value));
    else controls[key].setValue(value);
    controls[key].clearValidators();

    if (validator && controls[key]) controls[key].setValidators(Validators.required);
    if (patternKey) controls[key].setValidators(Validators.pattern(patternKey));
  }
}
